import React from 'react'
import "./footer.css"

function Footer() {
  return (
    <footer className='footer'>
      <div className="footer_container container">
        <h1 className='footer_title'> Soubhik Ghosh</h1>
        <div className='footer_navbar'>
          <ul className='footer_list'>
            <li>
              <a href="#aboutme" className='footer_link'>About</a>
            </li>

            <li>
              <a href="#skills" className='footer_link'>Skills</a>
            </li>

            <li>
              <a href="#portfolio" className='footer_link'>Portfolio</a>
            </li>
          </ul>
        </div>

        <div className='footer_social'>
          <a href="https://www.instagram.com/_iamblaze_/?igshid=YmMyMTA2M2y%3D/" className='footer_social_link' target={'_blank'}>
            <i class="uil uil-instagram"></i>
          </a>

          <a href="https://twitter.com/Soubhik05302962?t=kEkefTq8n5L5HancQJrmfw&s=09" className='footer_social_link' target={'_blank'}>
            <i class="uil uil-twitter"></i>
          </a>

          <a href="https://www.linkedin.com/in/soubhik285/" className='footer_social_link' target={'_blank'}>
            <i class="uil uil-linkedin"></i>
          </a>
        </div>

        <span className='rights_reserved'>&#169;soubhik285. All rights Reserved</span>
      </div>

    </footer>
  )
}

export default Footer
